import React, { useEffect, useState } from "react";

import { useHistory, useLocation, useParams } from "react-router-dom";

import ViewEdit from "../../../../../../presentation/pages/admin/super-devs/edit";
import { toastUtils } from "../../../../../../utils";
import { UserProps } from "../../../../../../domain/models/user";
import { makeRemoteSuperDev } from "../../../../usecases/user/remote-user-factory";

const MakeSuperDevEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const edit = id ? searchParams.get("edit") === "true" : true;

  const history = useHistory();

  const [data, setData] = useState<UserProps>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      setLoading(true);
      makeRemoteSuperDev().findById(Number(id)).then((response) => {
        setData(response);
      }).catch((error) => {
        console.error("Error fetching Super Dev:", error);
      }).finally(() => {
        setLoading(false);
      });
    };

    if (!id) {
      setLoading(false);
      return;
    }

    const idNumber = Number(id);
    if (Number.isNaN(idNumber)) {
      toastUtils.showMessage({
        type: "error",
        message: "ID inválido fornecido.",
      });
      return;
    }

    fetchData();
  }, [id]);

  const goBack = (): void => {
    history.goBack();
  };

  const create = async (values: any): Promise<void> => {
    try {
      await makeRemoteSuperDev().create({
        email: values?.email,
        name: values?.name,
      });
      toastUtils.showMessage({
        type: "success",
        message: "Salvo com Sucesso",
      });
    } catch (error: any) {
      toastUtils.showMessage({
        type: "error",
        message: `Erro ao salvar Super Dev: ${error?.detail || error?.userMessage
          }`,
      });
    }
  };

  const update = async (values: any): Promise<void> => {
    const userId = Number(id);

    if (Number.isNaN(userId)) {
      toastUtils.showMessage({
        type: "error",
        message: "ID inválido fornecido.",
      });
      return;
    }

    try {
      await makeRemoteSuperDev().update(userId, {
        email: values?.email,
        name: values?.name,
      });
    } catch (error: any) {
      toastUtils.showMessage({
        type: "error",
        message: `Erro ao atualizar Super Dev: ${error?.detail || error?.userMessage
          }`,
      });
    }
  };


  const handleSubmit = async (values: any, actions: any): Promise<void> => {
    actions.setSubmitting(true);
    if (!id) {
      await create(values);
      goBack();
      return;
    }

    await update(values);

    actions.setSubmitting(false);
    goBack();
  };

  const handleEdit = (): void => {
    searchParams.set("edit", "true");
    history.replace({ search: searchParams.toString() });
  };

  return (
    <ViewEdit
      onSubmit={handleSubmit}
      data={data}
      edit={edit}
      loading={loading}
      id={id}
      handleEdit={handleEdit}
    />
  );
};

export default MakeSuperDevEdit;
